<template>
  <div class="container-fluid page-user">
    <div class="row mt-4">
      <div class="col-6">
        <p class="page-title">
          <i class="fas fa-file-invoice"></i> Users
        </p>
      </div>
      <div class="col-6">
       <button type="button" class="btn btn-primary btn-sm mr-2 float-right" @click="createNewUser">
          <i class="fas fa-plus"></i> Create User
        </button>    
      </div>
    </div>
    <div class="row">
      <div class="col">
        <GridTable :data="gridData" :columns="gridColumns" :filter-key="searchQuery" />
        <b-pagination
          size="sm"
          v-model="page"
          :per-page="perPage"
          :total-rows="totalRows"
          align="center"
          @change="changePage($event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import router from '@/router';
import { BPagination } from 'bootstrap-vue';
import GridTable from '@/components/MarketplacesGrid/MarketplacesGrid.vue';

import UsersApiRequest from '@/components/ApiRequester/Users.js';

export default {
  name: 'Users',
  components: {
    GridTable,
    BPagination,
  },
  data() {
    return {
      searchQuery: '',
      totalRows: 0,
      page: 1,
      gridData: [],
      gridColumns: [
        {
          column: 'User',
          index: 'user',
          type: 'link',
          path: '/users/:id/edit',
          align: 'left',
        },
        {
          column: 'Role',
          index: 'role',
          type: 'raw',
          align: 'left',
        },
        {
          column: 'Status',
          index: 'status',
          type: 'raw',
          align: 'left',
        },
        {
          column: 'Last Activity (PST)',
          index: 'last_activity_pst',
          type: 'raw',
          align: 'left',
        },
         {
          column: 'Event',
          index: 'event',
          type: 'raw',
          align: 'left',
        },
      ],
    };
  },
  computed: {
    perPage: () => 50
  },
  mounted() {
    document.getElementById('loader').classList.add('active');
    this.fetchUsers().then((response => {
      const { total, data } =  response;
      this.gridData = data;
      this.totalRows = total;
      document.getElementById('loader').classList.remove('active');
    })).catch(() => {
      document.getElementById('loader').classList.remove('active');
    });
  },
  methods: {
    fetchUsers() {
      const ApiRequest = new UsersApiRequest();
      return ApiRequest.all().then((response) => response.data);
    },
    createNewUser() {
      router.push('/users/create')
    }
  },
};
</script>
